module.exports = __webpack_public_path__ + "img/logoCAS1b.29482440.png";